module.exports = __webpack_public_path__ + "static/media/86.31718b9b.jpg";